/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import routes from "./routes"; // import store, { types } from '../store'

Vue.use(Router);
var router = new Router({
  routes: routes
});
router.beforeEach(function (to, from, next) {
  // store.commit(types.UPDATE_LOADING_STATUS, { loading: true })
  next();
});
router.afterEach(function (to, from) {
  setTimeout(function () {// store.commit(types.UPDATE_LOADING_STATUS, { loading: false })
  }, 500);
  document.title = to.meta.title;
});
export default router;